"use client"

import EventsImage from "../../assets/images/events.png";
import {withLocaleInURI} from "../../internationalization/i18nURI";
import {useStores} from "../../stores/useStores";
import {SchoolFeedMobileWidgetLink} from "./SchoolFeedMobileWidgetLink";
import {useSchoolFeedUrlQuery} from "../../hooks/useSchoolFeedData";

function useEventsUrl() {
    const {i18nStore} = useStores();
    const urlQuery = useSchoolFeedUrlQuery()

    return {
        pathname: withLocaleInURI("/feed", i18nStore.currentAppSupportedLocale),
        query: {...urlQuery, type: "events", currentView: "content"}
    }
}

export function MobileEventsWidgetLink(props: {
    active: boolean;
}) {
    const href = useEventsUrl();
    return <SchoolFeedMobileWidgetLink
        href={href}
        active={props.active}
        src={EventsImage}
        text={"Events"}
    />
}